import styled from 'styled-components';
import { breakpoint, Grid, Row, Col } from '@grays-npm/component-library';
import { PropsWithChildren } from 'react';

type GridContainerProps = {
  addBottomBorder: boolean;
  addMarginTop: boolean;
};

const GridContainer = styled(Grid)<GridContainerProps>`
  ${({ addMarginTop, theme }) =>
    addMarginTop &&
    breakpoint('md')`
      margin-top: ${theme.spacings[10].rem};
  `}

  ${({ addBottomBorder, theme }) =>
    addBottomBorder &&
    `
     border-bottom: 1px solid ${theme.colors.neutrals.solidGrays[6]};
     padding-bottom: ${theme.spacings[4].rem};
  `}

  overflow: visible;
  margin-bottom: ${({ theme }) => theme.spacings[7].rem};

  ${breakpoint('sm')`
    border-bottom: none;
    padding-bottom: 0;
  `}

  ${breakpoint('md')`
    margin-bottom: ${({ theme }) => theme.spacings[10].rem};
  `}
`;

const TopRow = styled(Row)`
  background-color: ${({ theme }) => theme.colors.neutrals.solidGrays[8]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutrals.solidGrays[6]};

  ${breakpoint('sm')`
    background: none;
    border: none;
  `}
`;

const BorderedContentCol = styled(Col)`
  ${breakpoint('md')`
    padding: ${({ theme }) => theme.spacings[7].rem};
    border: 1px solid ${({ theme }) => theme.colors.neutrals.solidGrays[6]};
    border-radius: ${({ theme }) => theme.borderRadius.default};
    overflow: visible;
  `}
`;

const BottomRow = styled(Row)`
  border-top: 1px solid ${({ theme }) => theme.colors.neutrals.solidGrays[6]};
  margin-top: ${({ theme }) => theme.spacings[4].rem};

  ${breakpoint('sm')`
    border-top: none;
    margin-top: 0;
  `}
`;

export type PageLayoutProps = PropsWithChildren<{
  topChildren?: string | React.ReactNode;
  bottomChildren?: string | React.ReactNode;
}>;

const PageLayout: React.FC<PageLayoutProps> = ({
  topChildren,
  children,
  bottomChildren,
}) => {
  return (
    <GridContainer
      addBottomBorder={!bottomChildren}
      addMarginTop={!topChildren}
    >
      {topChildren && (
        <TopRow center>
          <Col sm={4} md={6} lg={10}>
            {topChildren}
          </Col>
        </TopRow>
      )}
      <Row center>
        <BorderedContentCol sm={4} md={6} lg={10}>
          {children}
        </BorderedContentCol>
      </Row>
      {bottomChildren && (
        <BottomRow center>
          <Col sm={4} md={6} lg={10}>
            {bottomChildren}
          </Col>
        </BottomRow>
      )}
    </GridContainer>
  );
};

export default PageLayout;
